import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'hash'
})
export class hash implements PipeTransform {
    transform(value: string): string {
        const regex = /#[A-zÀ-ú]*|=[A-zÀ-ú]*|\*[A-zÀ-ú]*|@[A-zÀ-ú]*|\+[A-zÀ-ú]*/gm;
        const match = value.match(regex);

        if (match !== null) {
            for (const word of match) {
                value = value.replace(word, `<strong>${word}</strong>`)
            }
        }

        return value;
    }
}
